export const STATUS_OPTIONS = [
  { value: "idea", label: "Idee", color: "bg-bone text-ink border-border" },
  { value: "planned", label: "Geplant", color: "bg-[#FBF1DE] text-[#9A7330] border-[#E9D6A8]" },
  { value: "booked", label: "Gebucht", color: "bg-[#E8EFE9] text-[#4F6357] border-[#C8D6CB]" },
  { value: "experienced", label: "Erlebt", color: "bg-[#F5E2DA] text-[#9C3A23] border-[#E0B4A1]" },
  { value: "repeat", label: "Wiederholen", color: "bg-ink text-alabaster border-ink" },
  { value: "archived", label: "Archiviert", color: "bg-bone text-text_secondary border-border" },
];

export const StatusBadge = ({ status, size = "sm" }) => {
  const opt = STATUS_OPTIONS.find((s) => s.value === status) || STATUS_OPTIONS[0];
  const padding = size === "sm" ? "px-2.5 py-0.5 text-[11px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border tracking-wide ${padding} ${opt.color}`}
    >
      {opt.label}
    </span>
  );
};

export default StatusBadge;
